import PropertyConstants from 'app/shared/constants/PropertyConstants';

const enterpriseUtils = {
    getMustSetCustomerId: (listing = {}, user = {}, paidMultifamilyLocation = false) => {
        const { propertyType, customerId, isRoomForRent } = listing;
        const {
            isSingleFamilyEnterpriseCustomer,
            isMultifamilyCustomer,
        } = user;
        const isCommunity = propertyType === PropertyConstants.PROPERTY_TYPES.COMMUNITY;

        if (!isSingleFamilyEnterpriseCustomer) {
            return false;
        }
        if (isRoomForRent && !isCommunity) {
            return false;
        }
        if (isCommunity && paidMultifamilyLocation && isMultifamilyCustomer) {
            return false;
        }
        return !customerId;
    },
};

export default enterpriseUtils;
